"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateCreateContentMenuItem = void 0;
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var widgets_1 = require("@tableau/widgets");
var react_1 = __importDefault(require("react"));
var cssPrefix = 'content-menu-item';
var baseCreateButtonContainer = {
    fontSize: widgets_1.TabStyles.Typography.Sizing.Large,
    fontFamily: data_catalog_shared_1.vizPortalFontStyle.fontFamily,
    display: 'flex',
    flexGrow: 1,
    alignItems: 'center',
    flexDirection: 'row',
    height: '30px',
    paddingRight: widgets_1.TabStyles.Spacing.DefaultSpace,
    paddingLeft: widgets_1.TabStyles.Spacing.DefaultSpace,
};
var menuItemEnabledContainerCss = (0, data_catalog_shared_1.cssClass)(cssPrefix, __assign(__assign({}, baseCreateButtonContainer), { cursor: 'pointer', color: widgets_1.TabStyles.Typography.Color.Primary, $nest: {
        '&:hover': {
            backgroundColor: widgets_1.TabStyles.Colors.L3,
            color: widgets_1.TabStyles.Typography.Color.PrimaryDark,
        },
    } }));
var menuItemDisabledContainterCss = (0, data_catalog_shared_1.cssClass)(cssPrefix, __assign(__assign({}, baseCreateButtonContainer), { color: widgets_1.TabStyles.Typography.Color.Disabled }));
var menuTitleCss = (0, data_catalog_shared_1.cssClass)(cssPrefix, {
    paddingLeft: widgets_1.TabStyles.Spacing.MediumSpace,
});
var lightFontMenuTitleCss = (0, data_catalog_shared_1.cssClass)(cssPrefix, {
    color: widgets_1.TabStyles.Typography.Color.Disabled,
});
function generateCreateContentMenuItem(documentTypeTitle, resourceUsageTitle, iconSvg, testId, disabled) {
    return /** @class */ (function (_super) {
        __extends(CreateContentMenuItem, _super);
        function CreateContentMenuItem() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        CreateContentMenuItem.prototype.render = function () {
            var menuContainerCss = disabled
                ? menuItemDisabledContainterCss
                : menuItemEnabledContainerCss;
            return (react_1.default.createElement("div", { "data-tb-test-id": 'create-' + testId + '-button', className: menuContainerCss },
                iconSvg,
                react_1.default.createElement("div", { className: menuTitleCss },
                    react_1.default.createElement("div", null,
                        documentTypeTitle,
                        react_1.default.createElement("span", { className: lightFontMenuTitleCss }, resourceUsageTitle)))));
        };
        return CreateContentMenuItem;
    }(react_1.default.PureComponent));
}
exports.generateCreateContentMenuItem = generateCreateContentMenuItem;
//# sourceMappingURL=ContentMenuItems.js.map